import { render, staticRenderFns } from "./Contas.vue?vue&type=template&id=5d21834a&"
import script from "./Contas.vue?vue&type=script&lang=js&"
export * from "./Contas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports